var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5549 21.0544H17.8429V35.9986H13.5549V21.0544ZM15.5896 19.1852H15.5586C14.0063 19.1852 13 18.0428 13 16.5961C13 15.1199 14.0361 14 15.6194 14C17.2013 14 18.174 15.117 18.2051 16.5919C18.2051 18.0385 17.2013 19.1852 15.5896 19.1852ZM35 36H30.1377V28.2652C30.1377 26.241 29.3771 24.8605 27.7046 24.8605C26.4253 24.8605 25.7139 25.7917 25.3828 26.6918C25.2586 27.0129 25.278 27.4623 25.278 27.913V36H20.461C20.461 36 20.523 22.2997 20.461 21.0544H25.278V23.3998C25.5626 22.3743 27.1018 20.9107 29.5582 20.9107C32.6057 20.9107 35 23.0617 35 27.6891V36Z",
    fill: "#293E53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.684d6a27369f40fb5edc98fea4cb95f8.svg";
export { ForwardRef as ReactComponent };